import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button, Card, Select } from "antd";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { isCompositeComponent } from "react-dom/test-utils";
import { useNavigate } from "react-router-dom";

import "./CalendarFilter.css";
import TimelineBlock from "./TimelineBlock";

const MONTH = {
  0: "Jan",
  1: "Feb",
  2: "Mar",
  3: "Apr",
  4: "May",
  5: "Jun",
  6: "Jul",
  7: "Aug",
  8: "Sep",
  9: "Oct",
  10: "Nov",
  11: "Dec",
};

// eslint-disable-next-line no-extend-native
Date.prototype.getWeek = function () {
  let target = new Date(this.valueOf());
  let dayNr = (this.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  let firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay() + 7) % 7));
  }
  return 1 + Math.ceil((firstThursday - target) / 604800000);
};

const CalendarFilter = ({
  latestEndDate,
  setHeaderChange,
  userIds,
  defaultUserId,
  setUserid,
  datesWithData,
  hoursWithData,
  yellowHours,
  redHours,
  greenHours,
  activeDateMapping,
}) => {
  const [active, setActive] = useState("day");
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  const { Option } = Select;
  const navigate = useNavigate();

  const dayFilterSet = useCallback(() => {
    const dates = [];
    if (active === "month") {
      datesWithData.forEach((d) => {
        if (
          !dates.some(
            (date) => moment(date).utc().month() === moment(d).utc().month()
          )
        ) {
          dates.push(d);
        }
      });
    }
    if (active === "week") {
      datesWithData.forEach((d) => {
        if (
          !dates.some(
            (date) => moment(date).utc().week() === moment(d).utc().week()
          )
        ) {
          dates.push(d);
        }
      });
    }
    if (active === "day") {
      const dateSet = new Set();
      datesWithData.forEach((d) => {
        const currentDate = moment(d).startOf("day").toDate();
        dateSet.add(currentDate.toISOString());
      });
      dateSet.forEach((x) => dates.push(moment(x).toDate()));
    }
    setDates(dates);
  }, [active, datesWithData]);

  useEffect(() => {
    if (dates.length > 0 && selectedDate === "") {
      setSelectedDate(dates[dates.length - 1]);
    }
  }, [dates]);

  useEffect(() => {
    dayFilterSet();
  }, [dayFilterSet]);

  const handleActive = (key) => {
    setActive(key);
    dayFilterSet();
  };
  const contentWrapper = useRef(null);

  const sideScroll = (element, speed, distance, step) => {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        clearInterval(slideTimer);
      }
    }, speed);
  };

  const userIdChange = (value) => {
    setUserid(value);
    setHeaderChange(true);
    const url =
      "/detail-stress-chart?" +
      new URLSearchParams({ userId: value }).toString();
    navigate(url, { replace: true });
  };

  const titles = (active, date) => {
    const action = {
      realtime: () => {
        return {
          title: moment(date).format("DD"),
          subTitle: moment(date).format("YYYY MMM"),
        };
      },
      day: () => {
        return {
          title: moment(date).format("DD"),
          subTitle: moment(date).format("YYYY MMM"),
        };
      },
      week: () => {
        return {
          title: moment(date).week(),
          subTitle: "Week",
        };
      },
      month: () => {
        return {
          title: MONTH[moment(date).month()],
          subTitle: moment(date).year(),
        };
      },
    };
    return action[active]?.();
  };

  return (
    <>
      <div className="CalendarFilter">
        {/* <Button className="CalendarFilter__button"
                    type={active === "day" ? "primary" : "secondary"}
                    onClick={() => handleActive("day")}
                >
                    Short Term
                </Button> */}

        {/* <Select
                    className="controls__item"
                    value={defaultUserId}
                    bordered={false}
                    style={{ width: 160 }}
                    onChange={userIdChange}
                >
                    {userIds &&
                        userIds.map((userid, i) => {
                            return (
                                <Option value={userid.userid} key={`user-id-${i}`}>
                                    {userid.userid}
                                </Option>
                            );
                        })}
                </Select> */}
      </div>
      <div className="Days_wrapper">
        <div className="Days" ref={contentWrapper}>
          {active !== "raltime" &&
            dates &&
            dates.map((d) => {
              return (
                <CalendarCard
                  subTitle={titles(active, d)["subTitle"]}
                  title={titles(active, d)["title"]}
                  date={d}
                  active={active}
                  activeDateMapping={activeDateMapping}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              );
            })}
        </div>
        <div className="Arrows_left">
          <Button
            className="Arrows_button_left"
            shape="circle"
            icon={<ArrowLeftOutlined />}
            onClick={() => sideScroll(contentWrapper.current, 25, 100, -10)}
          />
        </div>
        <div className="Arrows_right">
          <Button
            className="Arrows_button_right"
            shape="circle"
            icon={<ArrowRightOutlined />}
            onClick={() => sideScroll(contentWrapper.current, 25, 100, 10)}
          />
        </div>
      </div>

      <TimelineBlock
        endDate={latestEndDate}
        active={active}
        activeDateMapping={activeDateMapping}
        hoursWithData={hoursWithData}
        yellowHours={yellowHours}
        redHours={redHours}
        greenHours={greenHours}
      />
    </>
  );
};

export default observer(CalendarFilter);

const CalendarCard = ({
  subTitle,
  title,
  date,
  active,
  activeDateMapping,
  selectedDate,
  setSelectedDate,
}) => {
  const handleClick = (date) => {
    setSelectedDate(date);
    activeDateMapping(active, date, true);
  };
  const isActive = date && selectedDate === date;

  return (
    <Card
      style={{ width: 60, height: 90, cursor: "pointer" }}
      key={date}
      className={isActive ? "CalendarCard active" : "CalendarCard"}
      onClick={() => handleClick(date)}
    >
      <p className="ClaendarCard__day">{subTitle}</p>
      <p className="CalendarCard__date">{title}</p>
    </Card>
  );
};
